import {
  Box, Container, Wrap,
  Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import PublicTransportUse from './components/report-sections/PublicTransportUse';
import PublicTransportFleetSize from './components/report-sections/PublicTransportFleetSize';
import PublicTransportCommunityServiced from './components/report-sections/PublicTransportCommunityServiced';
import PublicTransportCommunities from './components/report-sections/PublicTransportCommunities';
import PublicTransportExpenditure from './components/report-sections/PublicTransportExpenditure';
import PublicTransportTotalMobilityUse from './components/report-sections/PublicTransportTotalMobilityUse';
import PublicTransportTotalMobilityCommunities from './components/report-sections/PublicTransportTotalMobilityCommunities';
import PublicTransportReportHeader from './components/report-headers/PublicTransportReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';

function PublicTransport() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Public Transport and Total Mobility"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>This page provides annual reporting on a range of Public Transport and Total Mobility usage indicators for public transport within the network or the region: passenger travel, vehicle travel, fleet size, serviced population, etc. Some reporting is specifically for the selected network and some reporting is only available for the region.</Text>
              <Text>In addition to this page, NZTA provides monthly and quarterly reporting and data updates for public transport, see the links below. The NZTA annual and quarterly performance reports also provide statistics and summaries for public transport in New Zealand.</Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <PublicTransportReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <PublicTransportUse />
            <PublicTransportFleetSize />
            <PublicTransportCommunityServiced />
            <PublicTransportCommunities />
            <PublicTransportExpenditure />
            <PublicTransportTotalMobilityUse />
            <PublicTransportTotalMobilityCommunities />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default PublicTransport;
